import React from 'react'
import {
  makeStyles,
  Button,
  Drawer,
  Link,
  Typography
} from '@material-ui/core'
import useMenuVisibility from './useMenuVisibility'
import { IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { FacebookIcon, TwitterIcon } from '../../icons'
import { MENU } from '../app/constants/site.js'

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    },
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left'
    },
    '& .MuiIconButton-root': {
      borderRadius: '50%'
    }
  },
  panelPaper: {
    width: 385,
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    padding: theme.spacing(1),
    textAlign: 'right'
  },
  closeIcon: {
    fill: theme.palette.text.primary,
    width: '44px',
    height: '44px'
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    width: '44px',
    height: '44px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  closeText: {
    fontFamily: 'var(--alt-font)',
    fontSize: '11.5px',
    color: 'var(--text)',
    position: 'absolute',
    bottom: '-5px',
    left: '0',
    right: '0',
    textAlign: 'center',
    width: '100%',
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  },
  linkBox: {
    padding: theme.spacing(7.5, 3, 0, 3)
  },
  menuLinks: {
    padding: theme.spacing(2.5, 0)
  },
  linkItem: {
    display: 'block',
    marginBottom: theme.spacing(4)
  },
  linkLink: {
    fontWeight: 300,
    fontSize: 20,
    // lineHeight: '1.2em',
    // textTransform: 'uppercase',
    // letterSpacing: '.01rem',
    color: theme.palette.text.primary,
    '&:hover': {
      color: theme.palette.text.primary
    },
    '&.whatsnew': {
      color: theme.palette.primary.main
    }
  },
  subLabel: {
    fontSize: 16,
    color: "#545454",
    paddingBottom: theme.spacing(1)
  },
  subMenu: {
    display: 'flex',
    flexDirection: 'row',
  },
  subLink: {
    fontFamily: theme.typography.button.fontFamily,
    fontSize: '1rem',
    // lineHeight: '1.2em',
    textTransform: 'uppercase',
    letterSpacing: '.01rem',
    color: theme.palette.text.primary,
    marginRight: '1em',
    '&:last-of-type': {
      marginRight: 0,
    }
  },
  footer: {
    padding: theme.spacing(0, 2, 3, 2)
  },
  footerItem: {
    padding: 0,
    minWidth: 0,
    width: 32,
    height: 32,
    marginRight: theme.spacing(1),
    '& .MuiSvgIcon-root': {
      fontSize: theme.spacing(4)
    }
  }
}))

const items = MENU.navItems
const verticalItems = MENU.verticalNavItems
const socials = MENU.socialItems
const socialIcons = {
  facebook: <FacebookIcon />,
  twitter: <TwitterIcon />
}

const MenuLinks = ({ items, classes = {} }) => (
  <div className={classes.root}>
    {Boolean(items.length) &&
      items.map((item, i) => (
        <div
          key={i}
          className={`${classes.item} ${item.id}`}
        >
          <Link
            className={`${classes.link}`}
            aria-label={item.label}
            href={item.url}
            variant="h5"
          >
            {item.label}
          </Link>
          {item.sublabel ?
            <Typography
              className={`${classes.subLabel}`}
              variant="h5"
            >
              {item.sublabel}
            </Typography>
          : null}
          {["opportunity", "trends", "early-childhood", "segregation"].includes(item.id) ?
            <MenuSubLinks
              parent={item}
              items={verticalItems.filter(verticalItem =>
                !(item.id === "early-childhood" && ["methods", "data"].includes(verticalItem.id))
              )}
              classes={{
                root: classes.subMenu,
                link: classes.subLink,
              }}
            />
          : null}
        </div>
      ))}
  </div>
)

const MenuSubLinks = ({ parent, items, classes = {} }) => (
  <div className={classes.root}>
    {Boolean(items.length) &&
      items.map((item, i) => (
        <Link
          key={i}
          className={`${classes.link} ${item.id}`}
          aria-label={item.label}
          href={`${parent.url}${item.url}`}>
          {item.label}
        </Link>
      ))}
  </div>
)

const MenuFooter = ({ socials, icons, classes = {} }) => (
  <div className={classes.root}>
    {Boolean(socials.length) &&
      socials.map((item, i) => (
        <Button
          key={i}
          className={classes.item}
          aria-label={item.label}
          target="_blank"
          href={item.url}>
          {item.icon ? icons[item.icon] : item.label}
        </Button>
      ))}
  </div>
)

const SedaMenu = ({ ...props }) => {
  const classes = useStyles()
  //const items = useSiteStore(state => state.menu)
  const [showMenu, toggleMenu] = useMenuVisibility()
  return (
    <Drawer
      open={showMenu}
      anchor="right"
      classes={{ root: classes.root, paper: classes.panelPaper }}
      {...props}>
      <IconButton
        className={classes.closeButton}
        size="small"
        aria-label="close"
        onClick={toggleMenu}
        {...props}>
        <CloseIcon className={classes.closeIcon} />
        <span className={classes.closeText}>Close</span>
      </IconButton>
      <div className={classes.linkBox}>
        {
          <MenuLinks
            classes={{
              root: classes.menuLinks,
              item: classes.linkItem,
              link: classes.linkLink,
              subLabel: classes.subLabel,
              subMenu: classes.subMenu,
              subLink: classes.subLink,
            }}
            items={items}
          />
        }
      </div>
      <div className={classes.footer}>
        <MenuFooter
          classes={{
            item: classes.footerItem
          }}
          socials={socials}
          icons={socialIcons}
        />
      </div>
    </Drawer>
  )
}

export default SedaMenu
